export class PbhRequestServiceablePostModel {
  public RequestId?: number;
  public Pn?: string;
  public Sn?: string;
  public Awb?: string;
  public FlightNo?: string;
  public XoNo?: string;
  public CarrierEnum?: number;
  public ForwardDateToCarrier?: Date;
  public EstimatedDeliveryDate?: Date;
  public Status?: Number;
  public SubmittedBy?: string;
  public SubmittedDate?: Date;
  public ShipmentType?: Number;
  public IsCid?: boolean;
  public CidDescription?: string;
  public OrderType?: Number;
  public OrderNumber?: Number;
}

export class PbhRequestServiceablePutModel {
  public id?: number;
  public RequestId?: number;
  public Pn?: string;
  public Sn?: string;
  public Awb?: string;
  public FlightNo?: string;
  public XoNo?: string;
  public CarrierEnum?: number;
  public FlightDate?: Date;
  public ForwardDateToCarrier?: Date;
  public EstimatedDeliveryDate?: Date;
  public Status?: Number;
  public ShipmentType?: Number;
  public IsCid?: boolean;
  public CidDescription?: string;
  public RejectionNote?: string;
  public RejectReasons?: string;
  public TtRejectionNote?: string;
  public SubmittedBy?: string;
  public SubmittedDate?: Date;
  public updatedBy?: string;
  public updatedDate?: Date;
  public OrderType?: Number;
  public OrderNumber?: Number;
}
